module.exports = __webpack_public_path__ + "static/media/WAVE-portada.f5596d07.png";